<template>
	<div :class="['blue-button', widthClass]">
		<b-button
			:disabled="disabled"
			@click="handleClick"
			class="rounded-pill position-relative"
			:class="{
				'button-opacity': loading,
			}"
		>
			<img
				v-if="type === 'compare'"
				src="@/assets/common/campare-up.svg"
				alt=""
			/>
			<img v-if="type === 'add'" src="@/assets/common/add-plus.svg" alt="" />
			<img
				v-if="type === 'withdraw'"
				src="@/assets/common/withdrawl.svg"
				alt=""
			/>
			<img v-if="type === 'filter'" src="@/assets/common/filter.svg" alt="" />
			<span v-if="!loading" class="text-nowrap align-self-center">{{
				text
			}}</span>
			<img
				v-if="type === 'downarrow'"
				src="@/assets/common/white-down-arw.svg"
				alt=""
			/>
			<div class="loader-position" v-if="loading">
				<Loader />
			</div>
		</b-button>
	</div>
</template>

<script>
import Loader from "@/components/Loader.vue";
export default {
	name: "PrimaryButton",
	components: {
		Loader,
	},

	props: {
		text: {
			type: String,
			default: "",
		},
		loading: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		widthClass: {
			type: String,
			default: "button-fit-content",
		},
	},
	methods: {
		handleClick() {
			if (!this.loading) {
				this.$emit("clicked");
			}
		},
	},
};
</script>

<style>
.button-opacity {
	opacity: 50%;
	height: 25px;
}
.loader-position {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.fix-loader-position {
	position: absolute;
	bottom: 5px;
	left: -11px;
}
.blue-button .spinner-border {
	height: 1.563rem;
	width: 1.563rem;
	margin-top: 0.188rem;
	border: 0.25em solid var(--color-white);
	border-right-color: transparent;
}

.blue-button .btn-secondary {
	background-color: var(--primary-blue);
	border: 1px solid var(--primary-blue);
	color: var(--color-white);
	padding: 0.25rem 1.125rem;
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-600);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.625rem;
	width: 100%;
	height: 30px;
}
.blue-button .btn-secondary.disabled,
.btn-secondary:disabled {
	opacity: 0.65;
}

.blue-button .btn-secondary:disabled {
	opacity: 0.65 !important;
}
.blue-button .btn-secondary:disabled {
	color: var(--color-white) !important;
	background-color: var(--primary-blue) !important;
	border-color: var(--primary-blue) !important;
	opacity: 0.65 !important;
}

.blue-button .btn-secondary:hover {
	box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
		2px 3px 7px 0px rgba(32, 99, 155, 0.2),
		7px 10px 12px 0px rgba(32, 99, 155, 0.17),
		44px 63px 22px 0px rgba(32, 99, 155, 0);
}

.blue-button .btn-secondary:focus {
	border: 1px solid var(--primary-blue);
	color: var(--color-white);
	box-shadow: none;
}

.blue-button .btn-secondary:disabled {
	box-shadow: none;
}

.blue-button .btn-secondary:focus {
	border: 1px solid var(--primary-blue);
	color: var(--color-white);
	box-shadow: none;
}

.blue-button .btn-secondary:not(:disabled):not(.disabled):active,
.blue-button .btn-secondary:not(:disabled):not(.disabled).active,
.blue-button .show > .btn-secondary.dropdown-toggle {
	color: var(--color-white);
	background-color: var(--primary-blue);
	border-color: var(--primary-blue);
	box-shadow: none;
}
.button-width {
	width: 5.625rem;
}
.button-save {
	width: 130px;
}
.btn-next {
	width: 90px;
}

.button-fit-content {
	width: fit-content;
}
.w-90px button {
	width: 90px !important;
	height: 28px;
}
.w-120px button {
	width: 120px !important;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.w-70px-btn button {
	width: 80px !important;
	height: 28px;
}
.w-110px button {
	width: 110px !important;
	height: 28px !important;
	display: flex;
	align-items: center;
	justify-content: center;
}
.w-142 {
	width: 142px;
}
</style>
